import { jsx as e } from "react/jsx-runtime";
import { Icons as i } from "./icons/index.js";
const d = 24, s = ({ name: t, size: o = d, title: r, ...n }) => {
  const c = i[t];
  return /* @__PURE__ */ e(c, { "aria-hidden": !0, height: o, width: o, title: r, ...n });
};
export {
  s as Icon
};
//# sourceMappingURL=Icon.js.map
